module.exports = __webpack_public_path__ + "img/cristiano.9d210a11.jpg";